import React from "react";
import { PulseLoader } from "react-spinners";
import { AlertTriangle } from "lucide-react";

interface ConfirmDisableModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  methodName?: string;
}

const ConfirmDisableModal: React.FC<ConfirmDisableModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  loading,
  methodName,
}) => {
  if (!isOpen) return null;

  const displayName = methodName?.trim() ? methodName : "this payment method";

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white w-full max-w-md rounded-lg p-6 shadow-lg">
        <div className="flex justify-center mb-4">
          <div className="bg-red-100 text-red-600 rounded-full p-4">
            <AlertTriangle size={28} />
          </div>
        </div>
        <h2 className="text-center text-xl font-semibold mb-2">
          Disable Payment Method
        </h2>
        <p className="text-center text-gray-600 mb-6">
          Are you sure you want to disable{" "}
          <span className="font-medium text-gray-800">{displayName}</span>?
          Buyers will no longer be able to select it at checkout. You can
          re-enable it at any time.
        </p>
        <div className="flex justify-between gap-3">
          <button
            onClick={onClose}
            disabled={loading}
            className="w-1/2 bg-gray-100 text-gray-800 rounded-md py-2 px-4 hover:bg-gray-200 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className="w-1/2 bg-red-600 text-white rounded-md py-2 px-4 hover:bg-red-700 disabled:opacity-50"
          >
            {loading ? (
              <PulseLoader size={6} color="#fff" />
            ) : (
              "Yes, Disable"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDisableModal;
